import * as React from 'react';
import { Title, Subtitle, ButtonGroup, Tag, Section, Tooltip } from '../';

interface Props {
  small?: string;
  title?: string;
  subtitle?: JSX.Element | string;
  image?: JSX.Element;
  tag?: string;
  tagType?: string;
  tagTooltip?: string;
  controls?: Array<any>;
}

const HeadingSection = ({
  small,
  title,
  subtitle,
  image,
  controls = [],
}: Props) => (
  <Section>
    <div className="level">
      <div className="level-left">
        {image !== undefined && image}
        <div>
          {small !== undefined && small}
          {title !== undefined && <Title>{title}</Title>}
          {subtitle !== undefined && <Subtitle>{subtitle}</Subtitle>}
        </div>
      </div>
      {controls.length > 0 && (
        <div className="level-right">
          <ButtonGroup>{controls}</ButtonGroup>
        </div>
      )}
    </div>
  </Section>
);

export default HeadingSection;
